<template lang="html">
  <!-- <div class="game-ip" ref="game-ip" @resize="connectPaireds(paired)"> -->
  <div class="game-ip" ref="game-ip" @resize="connectPaireds(paired)">
    <div class="game-ip__answers margin-bottom-20">
      <div
        v-for="(audio, key) in audios"
        class="game-ip__answers__item"
        :key="`audio-${key}`"
        :style="{ 'flex-basis': `${100 / audios.length}%`}"
      >
        <div class="game-ip__answers__item__circle">
          <div class="game-ip__answers__item__circle__info" :class="{ right: audio.pair != undefined && audio.selected, wrong: audio.pair != undefined && !audio.selected, selected: selected == audio }">
            {{ audio.index + 1 }}
          </div>
        </div>
        <div
          class="game-ip__answers__item__audio"
          :class="{ right: audio.pair != undefined && audio.selected, wrong: audio.pair != undefined && !audio.selected, selected: selected == audio }"
          :style="{ cursor: audio.pair == undefined ? 'pointer' : 'not-allowed' }"
          :ref="`audio-${audio.index}`"
        >
          <div class="game-ip__answers__item__audio--player">
            <button class="btn btn-success btn-small" @click.prevent="select(audio)">Select</button>
            <button class="btn btn-info small" @click.prevent="$event.target.nextElementSibling.play()" :disabled="(audioState[audio.index] && audioState[audio.index].playing)">Play</button>
            <!-- <button class="btn btn-info small" @click="$event.target.nextElementSibling.pause()" v-else>Pause</button> -->
            <audio
              :ref="`audio-player-${audio.index}`"
              :src="audio.audio"
              @playing="setAudioState(key, 'playing', true)"
              @pause="setAudioState(key, 'playing', false)"
              @ended="setAudioState(key, 'played', true)"
              @loadedmetadata="setAudioState(key, 'duration', $event.target.duration)"
            />
          </div>
          <div class="game-ip__answers__item__audio--text">
            <!-- {{  audioState[audio.index] }} -->
            {{ !audioState[key] ? '' : (audioState[key].played ? audio.text : audioState[key].text) }}
          </div>
        </div>
        <div class="game-ip__answers__item__svg game-ip__answers__item__svg--bottom">
          <svg height="25" width="25" v-show="(selected == audio) || (audio.selected || audio.pair != undefined)">
            <circle cx="12.5" cy="12.5" r="12.5" :class="{ right: audio.pair != undefined && audio.selected, wrong: audio.pair != undefined && !audio.selected, selected: selected == audio }" />
          </svg>
        </div>
      </div>
    </div>

    <div class="game-ip__answers">
      <div
        class="game-ip__answers__item"
        v-for="(image, key) in images"
        @click="select(image)"
        :key="`image-2-${key}`"
      >
        <div class="game-ip__answers__item__svg game-ip__answers__item__svg--top">
          <svg height="25" width="25" v-show="(selected == image) || (image.selected || image.pair != undefined)">
            <circle cx="12.5" cy="12.5" r="12.5" fill="red"  :class="{ right: image.pair != undefined && image.selected, wrong: image.pair != undefined && !image.selected, selected: selected == image }" />
          </svg>
        </div>
        <div class="game-ip__answers__item__circle">
          <div class="game-ip__answers__item__circle__info" :class="{ right: image.pair != undefined && image.selected, wrong: image.pair != undefined && !image.selected, selected: selected == image }">
            {{ image.pair == undefined ? '' : image.pair + 1 }}
          </div>
        </div>
        <image-loader
          :src="image.img"
          :class="{ right: image.pair != undefined && image.selected, wrong: image.pair != undefined && !image.selected, selected: selected == image }"
          :style="{ cursor: image.pair == undefined ? 'pointer' : 'not-allowed' }"
          :ref="`image-${image.index}`"
        />
      </div>
    </div>
    <div id="svgContainer" ref="svgContainer">
      <svg ref="svg">
        <path
          v-for="(line, index) in paired"
          :ref="`path-${index}`"
          :class="{ right: line.selected, wrong: !line.selected }"
          :key="`path-${index}`"
        />
      </svg>
    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">
        <transition name="fade">
          <gameFeedback :correct="question.hit" v-show="showFeedback"/>
        </transition>
        <div v-if="question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!question.hit && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "ImagePairing",
  data() {
    return {
      question: {},
      audios: [],
      images: [],
      index: 0,
      ended: false,
      selected: null,
      selecting: false,
      showInfo: false,
      showFeedback: false,
      audioState: {}
    };
  },
  props: {
    subTopic: {
      type: Object,
      default: () => ({})
    },
    topic: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    paired() {
      const answers = this.question.answers;
      if (answers) {
        return answers
          .map((a, key) => {
            let copy = cloneDeep(a);
            return { index: key, ...copy };
          })
          .filter(a => a.pair1 != null || a.pair2 != null);
      } else return [];
    },
    questions() {
      return this.subTopic.exercise.questions;
    },
    ...mapGetters({
      testMode: "isTestMode",
      isReview: "isReview",
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    })
  },
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  methods: {
    async setCurrent() {
      let qst = {},
          index = 0;
      for (const key in this.questions) {
        index = key;
        if (!this.questions[key].answered) {
          qst = this.questions[key];
          break;
        } else if (key == this.questions.length - 1) {
          qst = this.questions[key];
          this.ended = true;
        }
      }
      this.index = index;
      if (
        Object.keys(this.question).length == 0 ||
        qst._id !== this.question._id
      ) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
        this.splitAnswers(qst.answers);
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    splitAnswers(answers) {
      const copy = cloneDeep(answers);
      const audios = [];
      const images = [];
      copy.map((a, index) => {
        audios.push({
          group: 1,
          index: index,
          audio: a.audio,
          text: a.text,
          selected: a.selected,
          pair: a.pair1
        })
        images.push({
          group: 2,
          index: index,
          img: a.img,
          selected: a.selected,
          pair: a.pair2
        })
      })
      this.audios = this.$shuffle(audios);
      this.images = this.$shuffle(images);
    },
    async save(question) {
      let questionsCopy = cloneDeep(this.questions);
      let questionCopy = cloneDeep(question);
      let scoreQuestions = 0;
      let answered = 0;
      for (const qst of questionsCopy) {
        let aswrScore = 0;
        for (const aswr of qst.answers) if (aswr.selected) aswrScore++;
        scoreQuestions += (aswrScore * 100) / qst.answers.length;
        if (qst.answered) answered++;
      }
      let questionScore = 0;
      this.$set(
        questionCopy,
        "hit",
        (questionScore * 100) / questionCopy.answers.length >= 70
      );
      const score = scoreQuestions / questionsCopy.length;
      let payload = {
        points: score,
        finished: false,
        question: questionCopy
      };
      if (answered == questionsCopy.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500)
        this.showInfo = true
      }

      gameBus.$emit("updateProgress", score);
      gameBus.$emit("setEnabled", true);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    select(img) {
      if (!this.selecting) {
        this.selecting = true;
        if (img.pair == undefined) {
          if (!this.selected) this.$set(this, "selected", img);
          else {
            if (this.selected.group != img.group) {
              this.$set(img, "pair", this.selected.index);
              this.$set(this.selected, "pair", img.index);
              this.$set(
                this.question.answers[img.index],
                `pair${this.selected.group}`,
                this.selected.index
              );
              this.$set(
                this.question.answers[this.selected.index],
                `pair${img.group}`,
                img.index
              );
              if (img.index == this.selected.index) {
                this.$set(this.question, "hit", true);
                this.$set(this.question.answers[img.index], "selected", true);
                this.$set(img, "selected", true);
                this.$set(this.selected, "selected", true);
              } else {
                this.$set(this.question, "hit", false);
                this.$set(this.question.answers[img.index], "selected", false);
                this.$set(
                  this.question.answers[this.selected.index],
                  "selected",
                  false
                );
                this.$set(img, "selected", false);
                this.$set(this.selected, "selected", false);
              }
              this.$set(this, "selected", null);
              this.$nextTick(async () => {
                await this.checkEnded(this.paired)
              })
            }
          }
        }
        this.selecting = false;
      }
    },
    signum(x) {
      return x < 0 ? -1 : 1;
    },
    absolute(x) {
      return x < 0 ? -x : x;
    },
    drawPath(svg, path, startX, startY, endX, endY, height) {
      var deltaX = (parseFloat(endX) - parseFloat(startX)) * 0.15;
      var deltaY = (endY - startY) * 0.15;
      // for further calculations which ever is the shortest distance
      var delta =
        deltaY < this.absolute(deltaX) ? deltaY : this.absolute(deltaX);
      // set sweep-flag (counter/clock-wise)
      // if start element is closer to the left edge,
      // draw the first arc counter-clockwise, and the second one clock-wise
      let arc1 = 0;
      let arc2 = 1;
      if (startX > endX) {
        arc1 = 1;
        arc2 = 0;
      }

      const startYSpace = -10;

      let more = (parseInt(height) + 1.2) * 5;
      // if (height < 2)  {
      //   more = (parseInt(height) + 1) * 10
      // } else if (height > 2) {
      //   more = (parseInt(height) - 2) * 10
      //   more = more - (more * 2)
      // }

      const deltaYMore = (endY - startY + more + startYSpace) * 0.15,
        deltaMore =
          deltaYMore < this.absolute(deltaX)
            ? deltaYMore
            : this.absolute(deltaX);

      // draw tha pipe-like path
      // 1. move a bit down, 2. arch,  3. move a bit to the right, 4.arch, 5. move down to the end
      path.setAttribute(
        "d",
        "M" +
          startX +
          " " +
          startY +
          " V" +
          (parseFloat(startY + startYSpace + more) + parseFloat(deltaMore)) +
          " A" +
          deltaMore +
          " " +
          deltaMore +
          " 0 0 " +
          arc1 +
          " " +
          (parseFloat(startX) +
            parseFloat(deltaMore) * parseFloat(this.signum(deltaX))) +
          " " +
          (parseFloat(startY + startYSpace + more) +
            2 * parseFloat(deltaMore)) +
          " H" +
          (parseFloat(endX) -
            parseFloat(deltaMore) * parseFloat(this.signum(deltaX))) +
          " A" +
          deltaMore +
          " " +
          deltaMore +
          " 0 0 " +
          arc2 +
          " " +
          endX +
          " " +
          (parseFloat(startY + startYSpace + more) +
            3 * parseFloat(deltaMore)) +
          " V" +
          endY
      );
    },
    connectElements(svg, path, startElem, endElem, height) {
      let svgContainer = this.$refs["svgContainer"];
      // if first element is lower than the second, swap!
      if (startElem.offsetTop > endElem.offsetTop) {
        const temp = startElem;
        startElem = endElem;
        endElem = temp;
      }

      // get (top, left) corner coordinates of the svg container
      const svgTop = svgContainer.offsetTop;
      const svgLeft = svgContainer.offsetLeft;

      // calculate path's start (x,y)  coords
      // we want the x coordinate to visually result in the element's mid point
      const startX =
        parseFloat(startElem.offsetLeft) +
        0.25 * parseFloat(startElem.offsetWidth) -
        parseFloat(svgLeft); // x = left offset + 0.5*width - svg's left offset
      let startY =
        parseFloat(startElem.offsetTop) +
        parseFloat(startElem.offsetHeight) -
        parseFloat(svgTop); // y = top offset + height - svg's top offset

      // calculate path's end (x,y) coords
      const endX = endElem.offsetLeft + 0.75 * endElem.offsetWidth - svgLeft;
      const endY = endElem.offsetTop - svgTop;

      // call function for drawing the path
      this.drawPath(svg, path, startX, startY, endX, endY, height);
    },
    async checkEnded(paired) {
      if (paired.length == this.question.answers.length) {
        let completed = true;
        for (const key in paired) {
          if (paired[key].pair1 == undefined || paired[key].pair2 == undefined)
            completed = false;
        }
        if (completed && !this.question.answered) {
          this.$set(this.question, "answered", true);
          this.feedback()
          await this.save(cloneDeep(this.question));
        }
      }
      this.connectPaireds(paired)
    },
    connectPaireds(paired) {
      const connected1 = [];
      const connected2 = [];
      for (const key in paired) {
        const svg = this.$refs["svg"];
        const path = this.$refs[`path-${key}`][0];
        let start = "",
            end = "";

        if (typeof paired[key].pair1 == 'number') {
          start = `audio-${paired[key].pair1}`;
          end = `image-${paired[key].index}`;
        } else {
          start = `audio-${paired[key].index}`;
          end = `image-${paired[key].pair2}`;
        }
        if (!connected1.includes(start) && !connected2.includes(end)) {
          connected1.push(start)
          connected2.push(end)

          const elStart = this.$refs[start][0],
                elEnd = this.$refs[end][0]
          if (elStart && elEnd)
            this.connectElements(svg, path, elStart, elEnd.el, key)
        }
      }
    },
    setAudioState (index, prop, value) {
      if (!this.audioState[index]) this.$set(this.audioState, index, {})
      if (!this.audioState[index].text) this.$set(this.audioState[index], 'text', '')
      this.$set(this.audioState[index], prop, value)
      if (!this.audioState[index].played && this.audioState[index].playing) this.startWordInterval(index, this.audios[index].text)
    },
    startWordInterval (index, word) {
      let count = 0,
          timeCount = 0
      const letterTime = (this.audioState[index].duration / parseInt(word.length)) * 1000,
            wordArray = word.split('')
      const interval = setInterval(() => {
        if (timeCount >= (this.audioState[index].duration * 1000)) return clearInterval(interval)
        if (!this.audioState[index].text) this.audioState[index].text = wordArray[count]
        else this.audioState[index].text += wordArray[count]
        this.$nextTick(() => {
          count++
          timeCount += letterTime
        })
      }, letterTime)
    },
    async viewQuestion(index) {
      if (this.ended && this.index != index) {
        const question = this.questions[index];
        if (question && question.answered) {
          this.index = index;
          this.$set(this, "question", question);

          if (!this.question.answered)
            this.question.answers = this.$shuffle(this.question.answers)

          this.splitAnswers(question.answers);
        }
      }
    },
    async feedback () {
      this.showFeedback = true
      await this.$delay(1500)
      this.showFeedback = false
      gameBus.$emit('setEnabled', true)
    },
    emitClose () {
      this.$refs['modal'].close()
    },
    closeModal () {
      this.showInfo = false
    }
  },
  watch: {
    question () {
      this.$nextTick(async () => {
        this.connectPaireds(this.paired);
        await this.$delay(75);
        await this.checkEnded(this.paired);
      });
    },
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  mounted() {
    const game = this.$refs["game-ip"];
    const obs = new ResizeObserver(elements => {
      this.connectPaireds(this.paired);
    });
    obs.observe(game);
    this.setCurrent()
    gameBus.$on("viewQuestion", this.viewQuestion)

    gameBus.$emit("updateProgress", this.subTopic.points)
    modalBus.$on("close", this.closeModal)
    gameBus.$on("setCurrent", this.setCurrent)
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion)

    modalBus.$off('close', this.closeModal)
    gameBus.$off("setCurrent", this.setCurrent)
  }
};
</script>

<style lang="scss">
.game-ip {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 10px;
  hr {
    height: 10px;
    width: 100%;
    background-color: #ddd;
    border: none;
    border-radius: 15px;
  }
  &__answers {
    flex-basis: calc(50% - 10px);
    flex-grow: 1;
    display: flex;
    z-index: 1;

    &__item {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      height: 150px;
      padding: 10px;
      &__circle {
        position: relative;
        &__info {
          position: absolute;
          display: flex;
          border-radius: 150px;
          width: 25px;
          height: 25px;
          justify-content: center;
          align-items: center;
          background-color: #afafaf;
          border: 1px solid #979797;
          color: #fff;
          top: 10px;
          left: 10px;
          &.right {
            background-color: #5ec12d;
          }
          &.wrong {
            background-color: #c2003c;
          }
          &.selected {
            background-color: #FFC200;
          }
        }
      }
      &__svg {
        position: relative;
        svg {
          position: absolute;
          circle {
            fill: #AFAFAF;
            transition: fill 0.2s;
            &.right {
              fill: #5ec12d;
            }
            &.wrong {
              fill: #c2003c;
            }
            &.selected {
              fill: #FFC200;
            }
          }
        }
        &--bottom {
          svg {
            top: -14px;
            left: 19.75%;
          }
        }
        &--top {
          svg {
            top: -10px;
            right: 19%;
          }
        }
      }
      img {
        width: calc(100% - 14px);
        height: calc(100% - 14px);
        margin: 0;
        border-radius: 10px;
        border: 7px solid transparent;
        &.right {
          border-color: #5ec12d;
        }
        &.wrong {
          border-color: #c2003c;
        }
        &.selected {
          border-color: #FFC200;
        }
      }
      &__audio {
        border: 5px solid #DDD;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // max-width: calc(100% - 14px);
        margin: 0;
        border-radius: 10px;
        &--player, &--text {
          flex-grow: 1;
        }
        &--player {
          display: flex;
          width: 100%;
          flex-basis: 70%;
          padding: 15px;
          button {
            flex-grow: 1;
            flex-basis: 50%;
            padding: 5px 10px;
            &:first-child { margin-right: 5px; }
            &:last-child { margin-left: 5px; }
          }
        }
        &--text {
          flex-basis: 30%;
        }
        &.right {
          border-color: #5ec12d;
        }
        &.wrong {
          border-color: #c2003c;
        }
        &.selected {
          border-color: #FFC200;
        }
      }
    }
  }
  &__option {
    display: flex;
    justify-content: flex-end;
    padding: 0 10px;
    z-index: 1;
  }
}

#svgContainer {
  height: 100%;
  width: 100%;
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
  svg {
    width: 100%;
    height: 100%;
    path {
      stroke-width: 5px;
      fill: none;
      &.right {
        stroke: #5ec12d;
      }
      &.wrong {
        stroke: #c2003c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/imagePairingGame.vue